export default __webpack_public_path__ + "static/factoryandwave-86b7cc8041e3f7326e75ecd53f07c6c0.png";